// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateCreditNoteMutationVariables = Types.Exact<{
  request: Types.InputMaybe<Types.CreateCreditNoteRequestDtoInput>;
}>;


export type CreateCreditNoteMutationResult = { __typename?: 'Mutation', createCreditNote: number };

export const CreateCreditNoteGql = gql`
    mutation CreateCreditNote($request: CreateCreditNoteRequestDTOInput) {
  createCreditNote(request: $request)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCreditNoteInjectable extends Apollo.Mutation<CreateCreditNoteMutationResult, CreateCreditNoteMutationVariables> {
    override document = CreateCreditNoteGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */